<template>
	<div>
		<div class="box">
			<div style="text-align: center;">
				<el-button type="primary" icon="el-icon-printer" @click="pdfBtn" class="pdfBtn">打印设置</el-button>
				<span style="display: block;color: red;margin-top: 10px;">备注：请在更多设置里把边距设置成 "无" ,并勾选 "双面打印" 。 </span>
				<!-- <button type="button" style="width: 120px;height: 50px;" @click="gotu">返回订单打印列表</button> -->
			</div>
			<div ref="bigbox">
				<div class="yl" id="box" ref="box">
					<div class="list" v-for="list in photolist" :key="list">
						<div class="CategoryName">{{list.CategoryName}}</div>
						<div class="SeriesName">{{list.SeriesName}}</div>
						<div class="Name">{{list.Name}}</div>
						<div class="Centering">{{list.Centering}}<span>Centering</span></div>
						<div class="Corners">{{list.Corners}}<span>Corners</span></div>
						<div class="Edges">{{list.Edges}}<span>Edges</span></div>
						<div class="Surface">{{list.Surface}}<span>Surface</span></div>
						<div class="LastScore">{{list.LastScore}}</div>
						<div class="Star" v-if="list.Star==1?true:false"><img src="../assets/未标题-1.png"></div>
						<div class="pe" v-if="list.PE==1||list.PE==3?true:false">PE</div>
						<div class="ce" v-if="list.PE==2||list.PE==3?true:false">CE</div>
					</div>
				</div>
				<div class="yl2" ref="box2">
					<div class="list" v-for="list in photolist" :key="list">
						<img :src="list.QRCode" class="QRCode" :class="{'xiaoshi':!list.QRCode}">
						<div class="QRFont">{{list.QRFont}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import print from 'td-print'

	export default {
		data() {
			return {
				token: localStorage.getItem('access_token'),
				photolist: [],
				printId: '',
				CollectiblesIds: [],
				listId: []
			}
		},
		created() {
			// let a = this.$route.query.currTableItem
			// this.listId = JSON.parse(a)
			// console.log(this.listId)
			// this.getlist()

			this.photolist = JSON.parse(localStorage.getItem('shuju'))
			console.log(this.photolist)
		},
		mounted() {
			// const data = this.$route.params.currTableItem
			// console.log(daat)
			// this.photolist = JSON.parse(data)
		},
		methods: {
			getlist() {
				console.log(this.photolist)
				this.listId.forEach((x) => {
					axios({
						method: 'get',
						url: this.$store.state.pcurl + "GetCollectiblesPoolModel?Id=" + x,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						this.photolist.push(res.data.Data)
					})
				})
			},
			gotu() {
				this.$router.push('/Orderprinting')
			},
			pdfBtn() {
				this.$confirm('是否打印, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					print(this.$refs.bigbox)

					let CollectiblesIds = []

					this.photolist.forEach((x) => {
						if (x.Id) {
							CollectiblesIds.push(x.Id)
						}
					})
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "Print?CollectiblesIds=" + CollectiblesIds,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						console.log(res)
					})


				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消打印'
					});
				});

			},
		}
	}
</script>

<style lang="less" scoped="scoped">
	.pdfBtn {
		margin-top: 30px;
	}

	.yl,
	.yl2 {
		height: 297mm;
		width: 210mm;
		padding-top: 12.5mm;
		padding-left: 5.5mm;
		margin: 0 auto;

		.list {
			display: inline-block;
			margin-right: 2.8mm;
			margin-bottom: 3mm;
			width: 65mm;
			height: 20mm;
			position: relative;
			// background: url(../assets/1227.png) no-repeat;
			// background-size: cover;
		}

		.CategoryName,
		.SeriesName,
		.Name {
			// font-family: 'Cambria';
		}

		.CategoryName {
			position: absolute;
			font-size: 0.75rem;
			left: 2.5mm;
			top: 1mm;
			-webkit-transform-origin-x: 0;
			-webkit-transform: scale(0.8);
			letter-spacing: -0.03125rem;
		}

		.SeriesName {
			position: absolute;
			font-size: 0.75rem;
			left: 23mm;
			top: 1mm;
			-webkit-transform-origin-x: 0;
			-webkit-transform: scale(0.8);
			letter-spacing: -0.03125rem;
		}

		.Name {
			position: absolute;
			font-size: 0.75rem;
			left: 2.5mm;
			top: 4.5mm;
			-webkit-transform-origin-x: 0;
			-webkit-transform: scale(0.8);
			letter-spacing: -0.03125rem;
		}

		.Centering,
		.Corners,
		.Edges,
		.Surface {
			// font-family: 'Cambria';
			font-size: 0.75rem;
			position: absolute;
			text-align: center;

			span {
				display: block;
				-webkit-transform-origin-x: 0.5;
				-webkit-transform: scale(0.7);
				margin-top: -0.3125rem;
			}
		}

		.Centering {
			top: 9mm;
			left: 2mm;
			width: 50px;
		}

		.Corners {
			top: 9mm;
			left: 16mm;
		}

		.Edges {
			top: 9mm;
			left: 28mm;
		}

		.Surface {
			top: 9mm;
			left: 38mm;
		}

		.list:nth-of-type(3n) {
			margin-right: 0;
		}

		.LastScore {
			// font-family: 'Cambria';
			position: absolute;
			letter-spacing: -0.1875rem;
			right: -0.5mm;
			top: 8.5mm;
			font-size: 1.75rem;
			width: 25%;
			text-align: center;
		}

		.Star {
			font-size: 0.75rem;
			position: absolute;
			right: 1.5mm;
			top: 6.5mm;

			img {
				width: 9px;
			}
		}

		.pe {
			position: absolute;
			right: 0.5mm;
			bottom: 1.5mm;
			font-size: 0.1rem;
			-webkit-transform-origin-x: 0;
			-webkit-transform: scale(0.6);
		}

		.ce {
			position: absolute;
			right: 0.5mm;
			bottom: 0mm;
			font-size: 0.1rem;
			-webkit-transform-origin-x: 0;
			-webkit-transform: scale(0.6);
		}
	}

	.yl2 {

		// height: 297mm;
		// width: 210mm;
		// padding: 15mm 6mm 12mm 3mm;
		// margin: 0 auto;
		align-content: flex-start;
		padding: 14mm 3mm 12mm 6mm;

		.list {
			position: relative;
			display: inline-block;
			margin-bottom: 3mm;
			width: 65mm;
			height: 20mm;
			margin-right: 0;
			margin-left: 2.8mm;
		}

		.list:nth-of-type(3n) {
			margin-left: 0;
		}

		display: flex;
		flex-wrap: wrap;
		flex-direction: row-reverse;

		.QRCode {
			position: absolute;
			top: 1mm;
			left: 19mm;
			width: 16mm;
			height: 16mm;
		}

		.QRFont {
			position: absolute;
			font-size: 0.75rem;
			-webkit-transform-origin-x: 0;
			-webkit-transform: scale(0.7);
			left: 20.5mm;
			bottom: 1mm;
		}
	}

	.xiaoshi {
		display: none;
	}
</style>
